import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';

import { fetchChannelAssets } from './fetchChannelAssets';

export function useChannelAssets() {
  const { isLoading, data, error } = useQuery({
    queryKey: queryKeys.channelAssets,
    queryFn: fetchChannelAssets,
    staleTime: Infinity,
  });

  return {
    isLoading,
    channelAssets: data?.channels,
    channelAssetsMap: data?.channelMap,
    error,
  };
}
